'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasUserAndTeamResponders = undefined;

var _getType = require('./getType');

var _getFallback = require('./getFallback');

var _ChatHeadingConfigTypes = require('../constants/ChatHeadingConfigTypes');

var hasUserAndTeamResponders = exports.hasUserAndTeamResponders = function hasUserAndTeamResponders(chatHeadingConfig) {
  return (0, _getType.getType)(chatHeadingConfig) === _ChatHeadingConfigTypes.USERS_AND_TEAMS || (0, _getType.getType)((0, _getFallback.getFallback)(chatHeadingConfig)) === _ChatHeadingConfigTypes.USERS_AND_TEAMS;
};